import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, contentChild, input, TemplateRef } from '@angular/core';
import { ValidationErrorType } from '../input-base.types';

@Component({
  selector: 'mbs-input-errors',
  templateUrl: './input-errors.component.html',
  imports: [NgTemplateOutlet],
  host: {
    class: 'mbs-form-feedback'
  }
})
export class InputErrorsComponent {
  public readonly errorsInput = input<Partial<ValidationErrorType>[] | null | undefined>([], { alias: 'errors' });
  public readonly errorsTemplateInput = input<TemplateRef<any> | null>(null, { alias: 'errorsTemplate' });

  public readonly errorsTemplateContent = contentChild(TemplateRef);

  protected readonly errors = computed(() => {
    const value = this.errorsInput();
    return Array.isArray(value) ? value : [];
  });
  protected readonly errorsTemplate = computed(() => this.errorsTemplateInput() ?? this.errorsTemplateContent());
}
